module.exports = __webpack_public_path__ + "static/media/apti_blog_DH100.dc9ccc96.jpg";